import { makeStyles } from "@mui/styles";
import { palette } from '../../../theme/doctorTheme'

export default makeStyles((theme: any) => ({
  cardButton: {
        display: 'flex',
        minWidth: '112px',
        flexDirection: 'column',
        padding: '1rem',
        alignContent: 'center',
        justifyContent: 'center',
        borderRadius: '0.75rem',
        gap: '0.75rem',
        backgroundColor: '#F5F7FB',
        border: '1px solid #E5E9F2',
        alignSelf: 'stretch',
        flex: '1 0 0',
        '&:hover': {
            backgroundColor: palette.lightGrey.dark,
        },
    },
    cardButtonLabel: {
        textWrap: 'nowrap',
    },
    cardButtonIcon: {
        width: '1.5rem',
        height: '1.5rem',
        fill: palette.textPrimaryColor.main,
    }
  }))
